import React from 'react';
import { connect } from 'react-redux';

import { makeGetTaskProjectTitle } from '../../../../../redux/projects/selectors';

// TODO: Add Skeleton instead of Loading...
const ConnectedProjectTitle = ({ title, projectId }) => {
  if (!projectId) {
    return null;
  }

  return !title ? <>Loading...</> : <>{title}</>;
}

const makeMapStateToProps = () => {
  const getTaskProjectTitle = makeGetTaskProjectTitle();
  return (state, props) => ({
    title: getTaskProjectTitle(state, props),
  });
};

export default connect(makeMapStateToProps)(ConnectedProjectTitle);
